const TAG_NAME = 'khushi-wishlist-product-action';
const BUTTON_SELECTOR = '[data-khushi-wishlist-product-action-button]';

if (!customElements.get(TAG_NAME)) {
  class KhushiWishlistProductAction extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.button = this.querySelector(BUTTON_SELECTOR);
      if (!this.button) return;

      this.handleClick = this.handleClick.bind(this);
      this.button.addEventListener('click', this.handleClick);
      this.syncWhenReady();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      this._connected = false;
    }

    syncWhenReady(attempt = 0) {
      const wishlist = window.khushiWishlist;
      if (wishlist?.updateButton && this.button) {
        wishlist.updateButton(this.button);
        return;
      }

      if (attempt < 30 && this.isConnected) {
        window.setTimeout(() => this.syncWhenReady(attempt + 1), 50);
      }
    }

    async handleClick(event) {
      const wishlist = window.khushiWishlist;
      if (!wishlist?.toggleFromButton || !this.button) {
        event.preventDefault();
        return;
      }

      const context =
        this.closest('product-form-component') ||
        this.closest('form') ||
        this.closest('.product-details') ||
        this;

      await wishlist.toggleFromButton(event, this.button, context);
    }

    sync() {
      if (window.khushiWishlist?.updateButton && this.button) {
        window.khushiWishlist.updateButton(this.button);
      }
    }
  }

  customElements.define(TAG_NAME, KhushiWishlistProductAction);
}

const syncAllProductActions = () => {
  document.querySelectorAll(TAG_NAME).forEach((action) => action.sync?.());
};

window.addEventListener('khushi:wishlist:changed', syncAllProductActions);
window.addEventListener('pageshow', syncAllProductActions);
document.addEventListener('shopify:section:load', () => requestAnimationFrame(syncAllProductActions));
